/* eslint-disable react/no-danger */
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { StyledSeoFaqContent } from './styles';
import type { SrpState } from '../../reducers';

export const SeoFaq = () => {
    const seoFaqContent = useSelector(({ resultsPage: { seoFaq } }: SrpState) => seoFaq);

    return seoFaqContent.length ? (
        <StyledSeoFaqContent>
            {seoFaqContent.map(({ title = '', description = '' }) => (
                <Fragment key={title}>
                    <h3>{title}</h3>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </Fragment>
            ))}
        </StyledSeoFaqContent>
    ) : (
        <></>
    );
};
